 <template>
  <div class="alert" v-show="visible">
    <div class="alert-bg">
      <div class="alert-text">{{ "暂不支持当前链，请选择其他支持公链" }}</div>
      <!-- <div class="alert-title">公链</div> -->
      <el-radio-group v-model="publicChain" @input="selectFunction">
        <el-radio
          v-for="(item, index) in publicChainOptions"
          :key="item.value"
          :label="item.name"
          :value="index"
          >{{ item.name }}</el-radio
        >
      </el-radio-group>
      <div class="flex-row">
        <!-- <div class="alert-btn-cancel" @click="$emit('update:visible', false)">
          取消
        </div> -->
        <div class="alert-btn" @click="$emit('update:visible', false);selectNetworkFunction()">
          切换
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { nodeConfigs } from "@/config/config.js";
export default {
  name: "nodeAlert",
  props: {
    visible:{
      required: true,
      type: Boolean,
    },
    mode:{
     required: true,
      type: String,
    },
  },
  data() {
    return {
      publicChainOptions: nodeConfigs,
      publicChain: "BSC Mainnet",
      chainId:56,
    };
  },
  beforeMount(){
    this.publicChainOptions = nodeConfigs.filter((item) => item.support.includes(this.mode));
  },
  methods: {
    selectFunction(value) {
      console.log("selectFunction=", value);
      var data = nodeConfigs.filter((item) => item.name == value);
      if (!data || data.length == 0) {
        return;
      }
      this.chainId = data[0].chainId;
       console.log("",this.chainId)
      // this.publicChain = data[0].chainId;
    },
    async selectNetworkFunction() {
      var data = this.publicChainOptions.filter((item) => item.chainId == this.chainId);
      console.log("selectNetwork=", data);
      if (!data || data.length == 0) {
        return;
      }
      console.log("switchEthereumChain=", this.chainId);
      try {
        await window.ethereum.request({
          method: "wallet_switchEthereumChain",
          params: [{ chainId: "0x" + this.chainId.toString(16) }],
        });
        console.log("wallet_switchEthereumChain");
      } catch (switchError) {
        console.log("switchError=", switchError);
        // This error code indicates that the chain has not been added to MetaMask.
        if (switchError.code === 4902) {
          try {
            await window.ethereum.request({
              method: "wallet_addEthereumChain",
              params: [
                {
                  chainId: "0x" + this.chainId.toString(16),
                  chainName: data[0].name,
                  rpcUrls: [data[0].rpc],
                 
                  nativeCurrency: {
                    name: data[0].symbol,
                    symbol: data[0].symbol,
                    decimals: 18,
                  },
                },
              ],
            });
          } catch (addError) {
            // Handle "add" error.
            console.log("addError=", addError);
            window.location.reload();
          }
        }
        if(switchError.code === 4001){
          //User rejected the request.
           window.location.reload();
        }
        // Handle other "switch" errors.
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.alert {
  position: fixed;
  z-index: 2000;
  top: 0px;
  left: 246px;
  width: calc(100% - 246px);
  height:calc(100%);
  background: rgba(0, 0, 0, 0);

  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  .alert-bg {
    margin-top: -150px;
    height: auto;
    min-width: 450px;
    max-width: 600px;
    background: #f8f8f8;
    border-radius: 20px;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    padding: 30px;
  }
  .el-icon-alert {
    color: #000;
    font-size: 55px;
  }

  .alert-text {
    font-weight: normal;
    font-size: 14px;
    color: rgb(216, 40, 40);
    line-height: 46px;
    text-align: center;
    font-style: normal;
    text-transform: none;
    padding: 0 20px;
    margin: 20px 0 50px 0;
  }
  .alert-title {
    text-align: left;
    width: 100%;
  }
  .alert-btn-cancel {
    width: 150px;
    height: 40px;
    // background-color: #4438d4;
    border-radius: 30px 30px 30px 30px;
    border: 1px solid rgb(61, 60, 60);

    font-weight: normal;
    font-size: 14px;
    color: rgb(61, 60, 60);
    line-height: 40px;
    text-align: center;
    font-style: normal;
    text-transform: none;

    margin: 50px 20px 20px 20px;

    cursor: pointer;
  }
  .alert-btn {
    width: 150px;
    height: 40px;
    background-color: #4438d4;
    border-radius: 30px 30px 30px 30px;
    border: 1px solid #695cff;

    font-weight: normal;
    font-size: 14px;
    color: #ffffff;
    line-height: 40px;
    text-align: center;
    font-style: normal;
    text-transform: none;

    margin: 50px 20px 20px 20px;

    cursor: pointer;
  }

  .alert-btn:hover {
    border: 1px solid #aba4ff;
  }
  /deep/.el-radio {
    color: rgb(61, 60, 60);
    font-weight: 500;
  }
  /deep/.el-radio__label {
    font-size: 16px;
  }
}
</style>
